export const BUSINESS = {
  name: "Sutra Interio",
  tagline: "Kolkata's Boutique Luxury Interior Design & Turnkey Execution Company",
  phone: "+91 62908 29020",
  phoneRaw: "+916290829020",
  whatsapp: "916290829020",
  email: "info@ssglobalconsultancy.com",
  address: "Sutra Interio, New Town, Kolkata 700135, West Bengal, India",
  mapEmbed:
    "https://www.google.com/maps?q=New+Town+Kolkata+700135&output=embed",
  social: {
    instagram: "https://instagram.com/sutrainterio",
    facebook: "https://facebook.com/sutrainterio",
    linkedin: "https://linkedin.com/company/sutrainterio",
    pinterest: "https://pinterest.com/sutrainterio",
  },
  googleReviewsUrl: "https://g.page/r/sutrainterio/review",
  rating: 4.9,
  reviewCount: 128,
};

export const BUDGETS = [
  "Below ₹5 Lakhs",
  "₹5 – 10 Lakhs",
  "₹10 – 20 Lakhs",
  "₹20 – 40 Lakhs",
  "₹40 Lakhs +",
];

export const PROPERTY_TYPES = ["1 BHK", "2 BHK", "3 BHK", "4 BHK +", "Villa / Duplex", "Commercial"];

export const SERVICE_OPTIONS = [
  "Residential Makeover",
  "Commercial Interiors",
  "Renovation",
  "Consultation",
];
